<h1>We have an example drawer open from component</h1>

<button ui-button buttonType="primary" (click)="close()">Confirm</button>
